import React from 'react'
import { useS4LContext } from '@s4l/react-context'

import { TextLink } from '@s4l/ds'
import { IconArrowRight } from '@s4l/icons/IconArrowRight'
import styles from './styles.module.css'

export interface IVoucherGuestRoomListCtaProps {
  bookNumber: number
  onClick: ({ bookNumber }: { bookNumber: number }) => void
  totalGuests: number
  isEnabled: boolean
  isMultiBooking: boolean
}

const VoucherGuestRoomListCta = ({
  bookNumber,
  onClick,
  totalGuests,
  isEnabled,
  isMultiBooking,
}: IVoucherGuestRoomListCtaProps) => {
  const { i18n } = useS4LContext()

  if (!isEnabled) {
    return null
  }

  const message = isMultiBooking
    ? i18n.formatMessage({ id: `guest-rooming-list.multibooking` }, { count: bookNumber })
    : i18n.formatMessage({ id: `global.fill-guest-details` }, { count: totalGuests })

  return (
    <TextLink
      as="button"
      onClick={() => onClick({ bookNumber })}
      size="medium"
      bold
      variant="neutral"
    >
      <span className={styles.link}>
        {message}
        <IconArrowRight size={16} data-testid="guest-room-list-cta-link-icon" />
      </span>
    </TextLink>
  )
}

export default VoucherGuestRoomListCta
